import { render, staticRenderFns } from "./VinnuskoliPage.vue?vue&type=template&id=587ff617&"
import script from "./VinnuskoliPage.vue?vue&type=script&lang=js&"
export * from "./VinnuskoliPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports